import React, { useCallback } from 'react'
import classNames from 'classnames'

import Icon from '../../Icon'

import styles from './Checkbox.module.css'

export default function Checkbox({ input, small, inverted, ...props }) {
  const { value, onChange } = input || props

  const handleClick = useCallback(
    e => {
      e.stopPropagation()
      e.preventDefault()

      onChange(!value)
    },
    [value, onChange]
  )

  let displayValue = value

  if (inverted && (!value || value === true)) {
    displayValue = !value
  }

  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(
          styles.checkbox,
          displayValue && styles.checked,
          small && styles.small
        )}
        onClick={handleClick}
      >
        {displayValue ? (
          displayValue === true ? (
            <div className={styles.icon}>
              <Icon
                icon={small ? 'checkmark-naked-small' : 'checkmark-naked'}
                color="white"
              />
            </div>
          ) : (
            <div className={styles.dash} />
          )
        ) : null}
      </div>
    </div>
  )
}
